import type { Notification, UnreadCount } from '@sirius/contracts';

import { request } from '../client';

const post = (path: string): Promise<unknown> =>
	request<unknown>(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });

export const listNotifications = (): Promise<Notification[]> => request<Notification[]>('/notifications');
export const getUnreadCount = (): Promise<UnreadCount> => request<UnreadCount>('/notifications/unread-count');
export const markNotificationRead = (id: string): Promise<void> =>
	post(`/notifications/${encodeURIComponent(id)}/read`).then(() => undefined);
export const markAllNotificationsRead = (): Promise<void> => post('/notifications/read-all').then(() => undefined);
